/* ===== UI Helper Functions ===== */
import { $ } from './helpers.js?v=83.21';
import { sanitizeImageSrc } from './url.js?v=83.21';

// Show snackbar notification with type support (success, error, info)
export function showSnackbar(text, type = 'info') {
  const b = $('snackbar');
  if (!b) return;
  b.textContent = text;
  
  // Remove existing type classes
  b.classList.remove('snackbar-success', 'snackbar-error', 'snackbar-info');
  
  // Add type class and show
  b.className = `show snackbar-${type}`;
  
  // Errors show longer (4s), others show 2.4s
  const duration = type === 'error' ? 4000 : 2400;
  setTimeout(() => {
    b.className = b.className.replace('show', '').trim();
  }, duration);
}

// Preview helper functions
export function clearPreview(elId) {
  const el = $(elId);
  if (el) el.replaceChildren();
}

export function appendPreview(elId, url) {
  const el = $(elId);
  if (!el) return;

  if (url && String(url).trim()) {
    // XSS-safe rendering: Use DOM API instead of innerHTML
    const safeUrl = sanitizeImageSrc(url);
    if (safeUrl) {
      const wrap = document.createElement('div');
      wrap.className = 'preview-img';
      const img = document.createElement('img');
      img.src = safeUrl;
      img.alt = 'preview';
      wrap.appendChild(img);
      el.appendChild(wrap);
    }
  } else {
    const w = document.createElement('div');
    w.className = 'preview-img';
    w.textContent = 'Nesetat';
    el.appendChild(w);
  }
}

// Compatibility for old single renders
export function renderPreview(elId, url) {
  clearPreview(elId);
  appendPreview(elId, url);
}

// Show upload progress
export function showUploadProgress(pct, text) {
  const wrap = $('uploadProgressWrap');
  const bar = $('uploadProgressBar');
  const txt = $('uploadProgressText');
  if (!wrap || !bar || !txt) return;
  wrap.classList.remove('hidden');
  bar.style.width = Math.max(1, Math.min(100, Math.round(pct))) + '%';
  txt.textContent = text || ('Se încarcă… ' + Math.round(pct) + '%');
  if (pct >= 100) {
    setTimeout(() => wrap.classList.add('hidden'), 800);
  }
}

// ✅ DEBUG E: Helper function to debug overlay blocking "Mod" button
export function debugHitTestSwitchChip() {
  const switchChip = document.getElementById('switchChip');
  if (!switchChip) {
    console.log('[debugHitTestSwitchChip] switchChip not found');
    return;
  }
  
  const rect = switchChip.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  
  const elementAtPoint = document.elementFromPoint(centerX, centerY);
  const activePopups = Array.from(document.querySelectorAll('.popup.active')).map(p => ({
    id: p.id || 'no-id',
    zIndex: window.getComputedStyle(p).zIndex,
    display: window.getComputedStyle(p).display,
    pointerEvents: window.getComputedStyle(p).pointerEvents
  }));
  
  console.log('[debugHitTestSwitchChip]', {
    switchChipRect: {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height,
      centerX: centerX,
      centerY: centerY
    },
    elementAtCenter: {
      tagName: elementAtPoint?.tagName,
      id: elementAtPoint?.id,
      className: elementAtPoint?.className,
      zIndex: elementAtPoint ? window.getComputedStyle(elementAtPoint).zIndex : 'N/A'
    },
    activePopups: activePopups,
    isSwitchChipClickable: elementAtPoint === switchChip || switchChip.contains(elementAtPoint)
  });
  
  return {
    elementAtCenter: elementAtPoint,
    activePopups: activePopups,
    isClickable: elementAtPoint === switchChip || switchChip.contains(elementAtPoint)
  };
}

// Expose globally
window.debugHitTestSwitchChip = debugHitTestSwitchChip;

// Close all popups helper (safe for global use)
export function closeAllPopups() {
  document.querySelectorAll('.popup.active').forEach(popup => {
    popup.classList.remove('active');
  });
  
  const safePopupIds = [
    'gdprPopup',
    'mktPopup',
    'autoRulesPopup',
    'opGDPRPopup',
    'opDPAPopup',
    'opTruthPopup',
    'vendorMKTPopup'
  ];
  safePopupIds.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('active');
  });
}

window.closeAllPopups = closeAllPopups;
